
import Swiper from './common/Swiper.vue';
import { reachGoal } from './utils/metrika.js';

const SWIPER_STYLES = `
    :host .swiper-wrapper {
        overflow: visible !important;
        align-items: center;
        height: 460px;
    }
    @media screen and (max-width: 1024px) {
        :host .swiper-wrapper {
            height: 100%;
        }
    }
`;


export default {
    name: 'MeatPageSupplierGallery',
    components: { Swiper },
    props: {
        data: { type: Object, default: () => ({}) },
        common: { type: Object, default: () => ({}) }
    },
    computed: {
        swiperOptions() {
            const realCount = this.data.items.length;

            return {
                slidesPerView: 'auto',
                spaceBetween: 12,
                loop: true,
                centeredSlides: true,
                autoplay: {
                    enabled: true,
                    speed: 6000,
                },
                navigation: {
                    enabled: true
                },
                pagination: {
                    clickable: true,
                    renderBullet: (index, className) => {
                        if (index >= this.data.items.length) return '';
                        return `<span class="${className}"></span>`;
                    }
                },
                on: {
                    navigationNext: () => {
                        this.reachGoal('click_supplier_gallery_next')
                    },
                    navigationPrev: () => {
                        this.reachGoal('click_supplier_gallery_prev')
                    },
                    slideChange: (swiper) => {
                        const realIndex = swiper.realIndex % realCount;
                        const bullets = swiper.pagination.bullets;
                        bullets.forEach((bullet, i) => {
                            bullet.classList.toggle('hide', i > realIndex + 4 || i < realIndex - 4);
                            bullet.classList.toggle('swiper-pagination-bullet-active', i === realIndex);
                        });
                    }
                },
                breakpoints: { 
                    0: { 
                        slidesPerView: 1,
                        spaceBetween: 8,
                        slidesOffsetBefore: 16,
                        slidesOffsetAfter: 16,
                    },
                    1025: { 
                        slidesOffsetBefore: 0,
                        slidesOffsetAfter: 0,
                        slidesPerView: 'auto',
                    } 
                },
                injectStyles: [SWIPER_STYLES],
            };
        },
    },
    methods: { reachGoal }
}
